exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bta-reservation-modal{\n\t position: fixed;\n\t left: 50%;\n\t top: 45%;\n\t transform: translate(-50%, -50%);\n}\n", ""]);

// exports
